import React from 'react';
import UserDp from '../../../assets/images/general-widget/testimonial.png';
import { EmployDetail, KelvinELedbetter } from '../../../Constant';
import { H5, P, Image } from '../../../AbstractElements';
import { Card, CardBody, Col } from 'reactstrap';
const TestimonialCard = () => {
  return (
    <Col xl='12' md='12' className='box-col-12 testimonial-widget'>
      <Card className='testimonial'>
        <CardBody>
          <Image className='img-90 user-img' src={UserDp} alt='' />
          <H5>{KelvinELedbetter}</H5>
          <P>{EmployDetail}</P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TestimonialCard;
